import { Theme, SxProps } from '@mui/material';

export type BadgeStatusProps = {
  statusColor?: BADGE_STATUS_COLOR;
  label: string;
  sx?: SxProps<Theme>;
  sxText?: SxProps<Theme>;
  textOnly?: boolean;
  icon?: React.ReactNode;
};

export enum BADGE_STATUS_COLOR {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  NONE = 'none',
}
